import { useGet } from '../../HttpClient';
import { ChargeOffReasonModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";
 
export function useChargeOffReasons() {
  const get = useGet(true, pillarCode);
  const getChargeOffReasons = (): Promise<ChargeOffReasonModel[]> => get(`${referenceDataBaseUrl}/charge-off-reasons`);
  return useQueryWithErrorHandling({
    queryKey: ['get-charge-off-reasons'],
    queryFn: async () => await getChargeOffReasons(),
  });
}

export function useRefreshChargeOffReasons() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['get-charge-off-reasons'] });
}
